import React from 'react';

import { icons } from '../../../../theme';
import { StyledButton } from './styles';

export const ButtonAppearances = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  stepIndicatorBtn: 'stepIndicatorBtn',
};

interface ButtonProps {
  appearance?: keyof typeof ButtonAppearances;
  as?: 'a' | 'button';
  type?: 'button' | 'submit' | 'reset';
  backIcon?: true | false;
  forwardIcon?: true | false;
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  title?: string;
  ariaLabel?: string;
  disabled?: boolean;
}

const Button = ({
  appearance = 'primary',
  as = 'button',
  type,
  backIcon,
  forwardIcon,
  children,
  onClick,
  title,
  ariaLabel,
  disabled,
}: ButtonProps) => (
  <StyledButton
    title={title}
    color={appearance}
    type={type}
    as={as}
    onClick={onClick}
    aria-label={ariaLabel}
    disabled={disabled}
  >
    {backIcon && icons.chevronLeftSVG}
    {children}
    {forwardIcon && icons.chevronRightSVG}
  </StyledButton>
);

export default Button;
